import gold from '@app/assets/img/coins/gold.svg';
import silver from '@app/assets/img/coins/silver.svg';
import usd from '@app/assets/img/coins/usd.svg';
import { useApplicationStateContext } from '@app/core/ApplicationStateProvider';
import { AppSvg } from '@itrustcapital/ui';
import React from 'react';
import { StyleProp, ViewStyle, Image } from 'react-native';

export interface AppCurrencyIconProps {
	style?: StyleProp<ViewStyle>;
	currency: string;
}

export function AppCurrencyIconComponent(props: AppCurrencyIconProps) {
	const { currencies } = useApplicationStateContext();

	if (props.currency === 'USD') {
		return <AppSvg style={props.style} xml={usd} />;
	} else if (props.currency === 'KMG') {
		return <AppSvg style={props.style} xml={gold} />;
	} else if (props.currency === 'KMS') {
		return <AppSvg style={props.style} xml={silver} />;
	} else {
		const currency = currencies.find((currency) => currency.ticker === props.currency);

		return <Image source={{ uri: currency?.logoUrl || '' }} style={props.style} />;
	}
}

export const AppCurrencyIcon = React.memo(AppCurrencyIconComponent, (prev, next) => {
	if (prev.currency !== next.currency) {
		return false;
	}

	return true;
});
